const closedRoadStrokeVariable = '--cc-map-road-closed-stroke';
const closedRoadBaseVariable = '--cc-map-road-closed-base';

export const closedRoadStyle = {
    weight: 4,
    color: `var(${closedRoadStrokeVariable})`,
    colorVariable: closedRoadStrokeVariable,
    baseColor: `var(${closedRoadBaseVariable})`,
    baseColorVariable: closedRoadBaseVariable,
    dashArray: '2 8', //First number is the length of the dash, second number is the length of the gap.
    lineCap: 'square',
    getBaseWeight: (weight: number, zoom: number, maxZoom: number) => weight + 2 + (zoom >= maxZoom - 1 ? 4 : 0),
} as const;
